import { ChakraStylesConfig } from "chakra-react-select/dist/types/types";
import { mergeWith } from "lodash-es";
import { chakraSelectStyles } from "shared/components/input/select/SelectStyles";
import { SelectOptionData } from "shared/components/input/select/SelectTypes";

export const selectButtonChakraStyles: ChakraStylesConfig<SelectOptionData> = {
  ...chakraSelectStyles,
  control: (provided, state) =>
    mergeWith({}, chakraSelectStyles.control?.(provided, state), {
      shadow: "xs",
      gap: "4px",
      "&.react-select__control--is-focused": {
        minWidth: "200px",
      },
      "&:has(.react-select__input:focus-visible:not([data-hidden]))": {
        ".react-select__placeholder": {
          display: "none",
        },
        ".react-select__search-placeholder": {
          visibility: "visible",
          display: "block",
          position: "absolute",
          gridArea: "1/1/2/3",
        },
        ".react-select__input-container": {
          gridArea: "1/1/2/4",
        },
        ".react-select__single-value": {
          visibility: "hidden",
        },
      },
      ".react-select--is-filter-button &": {
        borderRadius: "6px",
      },
      ".react-select--is-filter-button:not(.react-select--is-all-selected):not(.react-select--is-none-selected) &":
        {
          "&:not(.react-select__control--menu-is-open):has(.react-select__value-container--has-value)":
            {
              borderColor: "primary.300",
              background: "primary.50",
              color: "primary.800",
            },
        },
    }),
  container: (provided, state) =>
    mergeWith({}, chakraSelectStyles.container?.(provided, state), {
      ".react-select__value-container": {
        gap: "4px",
        gridTemplateColumns: "min-content",
      },
      ".react-select__value-container__wrapper": {
        gap: "4px",
        w: "100%",
        minWidth: "min-content",
      },
      "&:has(.react-select__input:focus-visible:not([data-hidden]))": {
        ".react-select__value-container": {
          ".react-select__input-container:first-of-type": {
            gridArea: "1/1/2/3",
          },
        },
        ".react-select__multi-value ": {
          display: "none",
        },
      },
    }),
  valueContainer: (provided, state) =>
    mergeWith({}, chakraSelectStyles.valueContainer?.(provided, state), {
      "&.react-select__value-container--has-value": {
        borderColor: "red",
      },
    }),
  inputContainer: (provided, state) =>
    mergeWith({}, chakraSelectStyles.inputContainer?.(provided, state), {
      mt: 0,
    }),
  singleValue: (provided, state) =>
    mergeWith({}, chakraSelectStyles.singleValue?.(provided, state), {
      mt: 0,
      minWidth: "min-content",
      textStyle: "bodyBold",
      color: "gray.700",
    }),
  multiValue: (provided, state) =>
    mergeWith({}, chakraSelectStyles.multiValue?.(provided, state), {
      mt: 0,
      mr: 0,
      textStyle: "bodyBold",
      color: "gray.700",
      overflow: "hidden",
      maxWidth: "150px",
      textOverflow: "ellipsis",
    }),
  placeholder: (provided, state) =>
    mergeWith({}, chakraSelectStyles.placeholder?.(provided, state), {
      mt: 0,
      display: "none",
      gap: "4px",
      "&.react-select__placeholder": {
        marginInline: 0,
        textStyle: "bodyBold",
        color: "gray.700",
        visibility: "visible",
        display: "flex",
        ".react-select__value-container--has-value &": {
          visibility: "hidden",
        },
      },
    }),
  menu: (provided, state) =>
    mergeWith({}, chakraSelectStyles.menu?.(provided, state), {
      right: 0,
    }),
  dropdownIndicator: (provided, state) =>
    mergeWith({}, chakraSelectStyles.dropdownIndicator?.(provided, state), {
      color: "gray.700",
    }),
};
